import SHA256 from "crypto-js/sha256";

// Organizations that may only be impersonated by an explicitly allow-listed
// operator (the `allowUsImpersonation` LaunchDarkly flag). Stored as SHA256
// digests because this module ships in the client bundle, where a readable
// customer name would be public.
//
// To gate another organization, add the digest of its LOWER-CASED, trimmed
// display name — the `organizationName` on the account row, NOT the slug (so the
// table's "Copy slug hash" button is the wrong source for this list, and these
// digests are not interchangeable with the slug digests in `PostHogService`):
//   printf '%s' "<lower-cased organization display name>" | shasum -a 256
//
// The gate normalizes the same way before hashing, so a digest of any other
// casing can never match. Note the gate ALLOWS impersonation when nothing
// matches, so a wrong or mis-cased digest silently grants access instead of
// denying it — verify a new entry against `SHA256(name.trim().toLowerCase())`
// before shipping it.
const US_ONLY_IMPERSONATION_ORGANIZATION_NAME_HASHES = new Set([
  "dd4efe815a51ab346b6033c5ccac6df1b645ebf7db4fb2e437437b3f3cf7a52c",
]);

const isUsOnlyImpersonationOrganization = (
  organizationName?: string
): boolean =>
  US_ONLY_IMPERSONATION_ORGANIZATION_NAME_HASHES.has(
    SHA256(organizationName?.trim().toLowerCase() ?? "").toString()
  );

interface ImpersonationAllowedParams {
  organizationName?: string;
  // `allowUsImpersonation` LaunchDarkly flag: base64-encoded usernames.
  allowUsImpersonation?: string[];
  username?: string;
}

// Gated organizations are impersonable only by allow-listed operators; every
// other organization is impersonable by anyone who can reach this screen.
export const isImpersonationAllowed = ({
  organizationName,
  allowUsImpersonation,
  username,
}: ImpersonationAllowedParams): boolean => {
  if (!isUsOnlyImpersonationOrganization(organizationName)) {
    return true;
  }

  return allowUsImpersonation?.includes(btoa(String(username))) ?? false;
};
